/**
 * Universal search API.
 */

import client from './client';

export async function universalSearch(query) {
  const { data } = await client.get('/search/', { params: { q: query } });
  return data;
}
